import axios from 'axios'

const axiosConfig = {
    baseURL: process.env.REACT_APP_API_URL
}

const api = axios.create(axiosConfig);

// Add a request interceptor
api.interceptors.request.use(function (config) {
    // Do something before request is sent
    const token = localStorage.getItem('token');

    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }

    if (window.isMobileApp()) {
        config.headers['X-Device-Data'] = JSON.stringify(window.device);
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

api.interceptors.response.use(response => {
    return response;
}, error => {

    if (!error.response) {
        // Error de red
        window.location = '/networkError';
        return Promise.reject(error);
    }

    const { status, data, config } = error.response;

    if (config?.url === '/v1/login/otp') {
        return Promise.reject(error);
    }

    switch (status) {

        case 401:
            localStorage.clear();
            window.location = '/';
            break;

        case 404:
            window.location = '/page404';
            break;

        case 503:
            window.location = '/page503';
            break;

        case 500:

            const errorId = data?.metadata?.[0]?.codigo;

            if (errorId) {
                window.location = `/page500?errorId=${errorId}`;
            } else {
                window.location = '/page500';
            }

            break;

        default:
            break;
    }

    return Promise.reject(error);;
});

export default api;